module.exports = __webpack_public_path__ + "b93d4fbf4488c2b82a079d5fd58435c2.svg";